module.exports = "<div class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">X Axis Label</label>\n    <div class=\"col-lg-6\">\n      <input type=\"text\" ng-model=\"visualization.options.xAxisLabel\" class=\"form-control\"></input>\n    </div>\n  </div>\n\n  <div class=\"form-group\">\n    <label class=\"col-lg-6\">Y Axis Label</label>\n    <div class=\"col-lg-6\">\n      <input type=\"text\" ng-model=\"visualization.options.yAxisLabel\" class=\"form-control\"></input>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/box-plot/box-plot-editor.html
// module id = 506
// module chunks = 1